import { render, staticRenderFns } from "./TemplateFTL.vue?vue&type=template&id=0ccfc600&scoped=true&"
import script from "./TemplateFTL.vue?vue&type=script&lang=js&"
export * from "./TemplateFTL.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFTL.vue?vue&type=style&index=0&id=0ccfc600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccfc600",
  null
  
)

export default component.exports